import { EQuantityValidationResult } from "projects/shared/lib/enum/quantity/quantity-validation-result.enum";

export class QuantityInputBareChangeResult {
  public valuePrevious?: number | undefined;
  public valueCurrent?: number;
  public validationResult?: EQuantityValidationResult;

  constructor(data?: QuantityInputBareChangeResult) {
    this.validationResult = EQuantityValidationResult.Unvalidated;

    if (data) {
      this.valuePrevious = data.valuePrevious;
      this.valueCurrent = data.valueCurrent;
      this.validationResult = data.validationResult;
    }
  }
}

